import { getFileExtension } from '@/components/fileIcon/file.utils';
import { cn } from '@/shadcn/lib/utils';
import { FileIcon as FileIconComponent, defaultStyles } from 'react-file-icon';

type Props = {
  name: string;
  className?: string;
};
export const FileIcon = ({ name, className }: Props) => {
  const fileExtension = getFileExtension(name);
  return (
    <div className={cn('shrink-0', className)}>
      <FileIconComponent
        extension={fileExtension}
        {...defaultStyles[fileExtension]}
      />
    </div>
  );
};
